// ** React Imports
import { useEffect, useState } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import dayjs from "dayjs";

// #####################################################

function formatTime(seconds) {
	const date = new Date(0);
	const updatedDate = dayjs(date).add(seconds, "second");
	return updatedDate.format("mm:ss");
}

// #####################################################

export const useBlockResendSms = () => {
	const [isResendDisabledByTime, setResendDisabledByTime] = useState(true);
	const [remainingTimeString, setRemainingTimeString] = useState("");
	const [remainingTimeNumber, setRemainingTimeNumber] = useState(0);

	const sentSmsCodeTime = useSelector((state) => state.auth.sentSmsCodeTime);
	const resendBlockTimeConst = useSelector((state) => state.auth.blockTime);

	const initialTime = sentSmsCodeTime
		? new Date(sentSmsCodeTime).getTime()
		: 0;

	useEffect(() => {
		const targetTime = initialTime + resendBlockTimeConst * 1000;

		setResendDisabledByTime(true);

		const timer = setInterval(() => {
			const currentTime = new Date().getTime();
			const remainingTime = Math.max(
				Math.floor((targetTime - currentTime) / 1000),
				0
			);
			setRemainingTimeNumber(remainingTime);

			setRemainingTimeString(formatTime(remainingTime));

			if (remainingTime <= 0) {
				setResendDisabledByTime(false);
				clearInterval(timer);
			}
		}, 1000);

		return () => clearInterval(timer);
	}, [initialTime, sentSmsCodeTime]);

	const setBlockResendSms = (block = true) => {
		setResendDisabledByTime(block);
	};

	return {
		isResendDisabledByTime,
		remainingTimeString,
		remainingTimeNumber,
		setBlockResendSms,
	};
};
